import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes'
// import App from './App'

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);